// extracted by mini-css-extract-plugin
export var editButton = "_my-0";